import { Component, OnInit, Input, HostListener, ElementRef } from '@angular/core';
import { SimpleGlobal } from "ng2-simple-global";
import { FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-typeahead-dropdown',
    templateUrl: './typeahead-dropdown.component.html',
    styleUrls: ['./typeahead-dropdown.component.css']
})
export class TypeaheadDropdownComponent implements OnInit {

    control_name: string = '';
    control_id: string = '';

    @Input() mainFormGroup: FormGroup;
    @Input() formArray: FormArray;
    @Input() formGName: FormGroup;
    @Input() fGroup: FormGroup;
    @Input() name: string;
    @Input() options: any[];
    @Input() labelName: any[];
    @Input() requiredField: any[];

    constructor(
        public global: SimpleGlobal,
        protected el: ElementRef
    ) {
    }

    ngOnInit() {
        this.control_name = this.name + '_name';
        this.control_id = this.name + '_id';
    }

    public changeTypeaheadNoResults(event, formGroup): void {

        if (formGroup.get(this.control_name).value == '') {

            formGroup.get(this.control_id).setValue(null);
        }
    }


    // TypeAhead functionality.
    OnSelect(event, formGroup) {
        
        formGroup.get(this.control_id).setValue(event.item.id);

        if (this.control_name == 'state_name') {

            formGroup.controls.district_name.setValue('');
        }
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/typeahead-dropdown/typeahead-dropdown.component.ts